import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { EclipseOfferingApiClientContext } from '../eclipse-offering.context';
export const fetchFeaturesGridQueryFn = async props => {
  const {
    httpClient,
    request: {
      productId
    }
  } = props;
  const {
    getFeaturesGrid
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = EclipseOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch features grid');
  }
  const featuresGridData = await getFeaturesGrid({
    productIds: [productId],
    ...p3Context
  });
  return {
    namespaces: (featuresGridData == null ? void 0 : featuresGridData.namespaces) ?? []
  };
};
//# sourceMappingURL=fetch-features-grid.query.js.map